import { SVGProps } from 'react';

const SunMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v2m4 8a4 4 0 0 0-4-4m7-3-1.256 1.256M20 12h2m-7.163 4.385a6.001 6.001 0 0 1-11.645.127 6 6 0 0 1 4.422-7.349c.624-.147.97.66.715 1.248a4 4 0 0 0 5.26 5.26c.589-.256 1.396.09 1.248.714"
    />
  </svg>
);
export default SunMoon;
